// extracted by mini-css-extract-plugin
export default {"Wrapper":"Banner2_Wrapper__Wze2X","Container":"Banner2_Container__dBDUs"};